import { userService, apiService } from 'services'
import { asyncTypes } from 'helpers/actionTypes'
import { loginFirebase } from 'store/firebase'
import { API, COUNTRY_CODE, LANGUAGE_CODE, STATUS_USER, TEACHER_TYPE } from 'constants/index'
import { dateHelper } from 'helpers'

const ACTION_USER_UPDATE = 'UserState/ACTION_USER_UPDATE'
export const GET_USER_INFO = asyncTypes('DashboardState/GET_USER_INFO')

export function getUserInfo() {
  return (dispatch) => {
    dispatch({ type: GET_USER_INFO.REQUEST })
    apiService.get(API.GET_USER_INFO_API).then(
      (response) => {
        if (!response.success) {
          return dispatch({ type: GET_USER_INFO.FAILURE, error: response.data })
        }
        if (response.data.profile?.time_zone) {
          dateHelper.setDefaultTimeZone(response.data.profile.time_zone)
        }
        dispatch(loginFirebase(response.data.profile.custom_token))
        dispatch(setUser(response.data.profile))
        dispatch({ type: GET_USER_INFO.SUCCESS, data: response.data.profile })
      },
      (error) => {
        dispatch({ type: GET_USER_INFO.FAILURE, error })
      }
    )
  }
}

export const setUser = (newUser) => (dispatch, getState) => {
  const { user } = getState()
  const userInfo = Object.assign(user, newUser)
  delete userInfo.time_zone_list
  dispatch({ type: ACTION_USER_UPDATE, payload: userInfo })
}

export const removeUser = () => (dispatch) => {
  userService.remove()
  dispatch({ type: ACTION_USER_UPDATE, payload: {} })
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [ACTION_USER_UPDATE]: (state, action) => {
    if (!action.payload) {
      return {}
    }
    userService.set(action.payload, true)
    return {
      ...state,
      ...action.payload,
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = userService.get()

export default function UserReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export const selectIsLoggedIn = (state) => !!(state.user && state.user.access_token)

export const selectTimeZone = (state) => state.user.time_zone

export const selectIsTeacherRareJob = (state) => state.user.teacher_source === TEACHER_TYPE.RARE_JOB

export const selectIsTeacherGGE = (state) => state.user.teacher_source === TEACHER_TYPE.GGE

export const selectIsTeacherMurpher = (state) => state.user.teacher_source === TEACHER_TYPE.MURPHER

export const selectIsTeacherBackOffice = (state) =>
  state.user.teacher_source === TEACHER_TYPE.TEACHER_SOURCE_BACK_OFFICE

export const selectIsTeacherKyna = (state) => state.user.teacher_source === TEACHER_TYPE.KYNA

export const selectIsUserPreDeactive = (state) => state.user?.status === STATUS_USER.PRE_DEACTIVE

export const selectIsUserDeactive = (state) => state.user?.status === STATUS_USER.DEACTIVE

export const selectIsFilledPaymentMethod = (state) => state.user.is_filled_payment_method === true

export const selectIsVietnameseTeacher = (state) => state.user.country_code === COUNTRY_CODE.VN

export const selectIsThailandTeacher = (state) => state.user.country_code === COUNTRY_CODE.TH

export const selectIsConfirmedForm = (state) => state.user.is_submitted_form === 1

export const selectContractNote = (state) => state.user.contract_note

export const selectContractStatus = (state) => state.user.contract_status

export const selectUser = (state) => state.user

export const selectUserCanCreateRequest = (state) => state.user?.can_create_request

export const selectCustomToken = (state) => state.user.custom_token

export const selectLanguage = (state) => {
  const isVietnameseTeacher = selectIsVietnameseTeacher(state)
  if (isVietnameseTeacher) return LANGUAGE_CODE.VN
  return LANGUAGE_CODE.EN
}

export const selectCountry = (state) => {
  const isVietnameseTeacher = selectIsVietnameseTeacher(state)
  if (isVietnameseTeacher) return COUNTRY_CODE.VN
  return LANGUAGE_CODE.EN
}
